import { useQuery } from '@tanstack/react-query';

import { PLAYER_DETAILS_PLAYER_SPONSORS_KEY } from '@/hooks/player-details/constants';
import { getPlayerSponsors } from '@/infrastructure/network/data/player-details/player-sponsors';
import { useOrganizationStore } from '@/store/organization-store';

interface PlayerSponsorsQueryArgs {
	playerUuid: string;
	isEnabled: boolean;
}

export const usePlayerSponsorsQuery = ({ playerUuid, isEnabled }: PlayerSponsorsQueryArgs) => {
	const store = useOrganizationStore();
	const enableQuery = Boolean(store.organizationUuid && store.teamLeagueUuid && playerUuid && isEnabled);

	return useQuery({
		queryKey: [PLAYER_DETAILS_PLAYER_SPONSORS_KEY],
		queryFn: () =>
			getPlayerSponsors({
				organizationUuid: store.organizationUuid,
				teamLeagueUuid: store.teamLeagueUuid,

				playerUuid: playerUuid
			}),
		enabled: enableQuery
	});
};
